import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import SectionTile from "./SectionTile";

const SectionSelector = ({ selectedSections, setSelectedSections }) => {
  const params = useParams();

  const classes = useSelector((state) =>
    state.pwaData?.taught_classes.filter((cls) =>
      cls.courses.includes(params.course_code)
    )
  );
  return (
    <div
      className="section-selector-container"
      // onClick={() => navigate("/Messages/course-messages")}
    >
      {classes?.map((cls) => (
        <SectionTile
          key={cls._id}
          cls={cls}
          selectedSections={selectedSections}
          setSelectedSections={setSelectedSections}
        />
      ))}
    </div>
  );
};

export default SectionSelector;
